import update from 'immutability-helper';
import { createSwitch, createCase } from 'helpers/action-helpers';
import { initialState } from './state';
import { SaveTenantAction, SaveTenantIdExistsAction, ProcessingTenantAction, 
  SetSettingsErrorMessageAction } from './actions';
  
export const settingsReducer = createSwitch(initialState, [
  createCase(new SaveTenantAction(initialState.tenant), (state, action) => {
    return update(state, {
      isProcessing: { $set: false },
      tenant: { $set: action.tenant }
    });
  }),
  createCase(new SaveTenantIdExistsAction(initialState.tenantIdExists), (state, action) => {
    return update(state, {
      tenantIdExists: { $set: action.exists }
    });
  }),
  createCase(new ProcessingTenantAction(), (state, action) => {
    return update(state, {
      isProcessing: { $set: true }
    });
  }),
  createCase(new SetSettingsErrorMessageAction(initialState.errorMessage), (state, action) => {
    return update(state, {
      isProcessing: { $set: false },
      errorMessage: { $set: action.message }
    });
  })
]);


// WEBPACK FOOTER //
// ./src/pages/settings/reducer.ts